import styled from 'styled-components';

export const Base = styled.div`
	margin: 20px 16px;
	flex-shrink: 0;
`;
